import http from '@/utils/services/http'

export default {
  find (leilao, lote, loteNum) {
    let url = `/api/patio/leilao/${leilao}?lote=${lote}`
    if (typeof loteNum === 'number') {
      url = `/api/patio/leilao/${leilao}?numero=${loteNum}`
    }
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/patio.js